"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShowExpandButton = void 0;
var _react = require("react");
var _constants = require("./constants");
const useShowExpandButton = ({
  caption,
  ref
}) => {
  const [showExpandButton, setShowExpandButton] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (ref.current) {
      setShowExpandButton(ref.current.clientHeight > _constants.MIN_OVERFLOW_HEIGHT);
    }
  }, [caption, ref]);
  return showExpandButton;
};
exports.useShowExpandButton = useShowExpandButton;
